import { action } from 'typesafe-actions';

import { AirportPayload } from 'reducers/airports';

export const AIRPORTS_REQUEST = 'AIRPORTS_REQUEST';
export const AIRPORTS_SUCCESSFUL = 'AIRPORTS_SUCCESSFUL';
export const AIRPORTS_FAILURE = 'AIRPORTS_FAILURE';

export const airportsRequest = () => action(AIRPORTS_REQUEST);

export const airportsSuccessful = ({ airports, cities, type }: AirportPayload) =>
  action(AIRPORTS_SUCCESSFUL, { airports, cities, type });

export const airportsError = (error: string) => action(AIRPORTS_FAILURE, error);
